import * as XLSX from "xlsx";

// Same row shape as utils/CSV.js (array of plain objects) so both exporters
// share one row-building function per section — whatever the user is
// currently viewing (filtered) is exactly what gets exported.
const exportExcel = (rows, filename = "data.xlsx") => {
  if (!rows || !rows.length) return;
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Analytics");
  XLSX.writeFile(workbook, filename);
};

export default exportExcel;
